import React, { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../../context/LanguageContext';

const API = process.env.REACT_APP_API_URL || '/api';

export default function ExportPanel() {
  const { t } = useLanguage();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');
  const [exporting, setExporting] = useState(false);

  const exportCsv = async () => {
    setExporting(true);
    try {
      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      if (status) params.status = status;

      const res = await axios.get(`${API}/admin/appointments/export`, {
        params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'cjpa-appointments.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export failed:', err);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div style={{ background: '#111827', border: '1px solid rgba(148,163,184,0.15)', padding: '1.5rem', marginBottom: '1.5rem' }}>
      <h6 style={{ color: '#D42B2B', fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>
        {t.admin.export?.title || 'Export Appointments'}
      </h6>
      <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <label className="form-label" style={{ fontSize: '0.7rem' }}>{t.admin.export?.startDate || 'Start Date'}</label>
          <input type="date" className="form-control form-control-sm" value={startDate}
            onChange={e => setStartDate(e.target.value)} style={{ colorScheme: 'dark' }} />
        </div>
        <div>
          <label className="form-label" style={{ fontSize: '0.7rem' }}>{t.admin.export?.endDate || 'End Date'}</label>
          <input type="date" className="form-control form-control-sm" value={endDate}
            onChange={e => setEndDate(e.target.value)} style={{ colorScheme: 'dark' }} />
        </div>
        <div>
          <label className="form-label" style={{ fontSize: '0.7rem' }}>{t.admin.export?.status || 'Status'}</label>
          <select className="form-select form-select-sm" value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">{t.admin.export?.allStatuses || 'All'}</option>
            <option value="pending">{t.dashboard.status.pending}</option>
            <option value="confirmed">{t.dashboard.status.confirmed}</option>
            <option value="in_progress">{t.dashboard.status.in_progress}</option>
            <option value="completed">{t.dashboard.status.completed}</option>
            <option value="cancelled">{t.dashboard.status.cancelled}</option>
          </select>
        </div>
        <button className="btn btn-primary btn-sm" onClick={exportCsv} disabled={exporting}>
          {exporting ? (t.admin.export?.exporting || 'Exporting...') : (t.admin.export?.exportCsv || 'Export CSV')}
        </button>
      </div>
    </div>
  );
}
